<template>
  <div>
    <Main
      ref="main"
      :loading="loading"
      :disabled="disabled"
      @reload="getData"
      @change="(e) => $emit('change', e)"
    >
      <div slot="header">
        <div class="d-flex mt-2">
          <div class="side-frame-success"></div>
          <div>
            <span style="font-size: 14px; color: #606266">
              {{ $l('form_title_ftyInboundDetail') || '入库单明细' }}
            </span>
            <el-divider
              direction="vertical"
              v-if="!disabled && this.table && this.table.length == 0"
            ></el-divider>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="chooseAmzSku()"
              v-if="!disabled && this.table && this.table.length == 0"
            >
              {{ $l('btn_chooseAmzSku') || '选择产品' }}
            </b-button>
          </div>
        </div>
      </div>
    </Main>
    <ChooseAmzFtySku
      :visible.sync="chooseAmzSkuVisible"
      :scmCode="scmCode"
      @confirm="skuConfirm"
    />
  </div>
</template>
<script>
import Main from './main.vue'
import ChooseAmzFtySku from '@/views/ecom/components/choose-amz-fty-sku'
export default {
  components: { Main, ChooseAmzFtySku },
  props: {
    disabled: { type: Boolean, default: false },
    amzFtyInboundCode: { type: String, default: '' },
    scmCode: { type: String, default: '' },
    table: { type: Array, default: () => [] },
  },
  data() {
    return { loading: false, chooseAmzSkuVisible: false }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (this.table && this.table.length > 0) {
        this.$refs.main.setData(this.table)
        return
      }
      if (!this.amzFtyInboundCode) return
      this.loading = true
      const res = await this.$api
        .ecomAmzFtyInboundDetailListApi({
          amzFtyInboundCode: this.amzFtyInboundCode,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      const { data } = res.body
      this.$refs.main.setData(data || [])
    },
    chooseAmzSku() {
      if (this.scmCode) return (this.chooseAmzSkuVisible = true)
      this.$message.warning(this.$l('tips_chooseAmzSku_Scm'))
    },
    async skuConfirm(data) {
      if (!data || !data.length) return
      const tableData = await this.getTableData()
      if (tableData && tableData.length) {
        data = data.filter(
          (i) => !tableData.map((j) => j.amzSkuCode).includes(i.amzSkuCode)
        )
      }
      if (!data || !data.length) return

      data = data.map((item) => ({
        ...item,
        amzSkuNcNo: item.ncNo,
        ncNo: item.ftyNcNo || item.ncNo,
        purchasePrice: item.ftyPrice,
        purchaseQty: 0,
        locationNo: '未上架',
      }))

      this.$refs.main.insertAt(data)
    },
    validate() {
      return this.$refs.main.validate()
    },
    getTableData() {
      return this.$refs.main.getTableData()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
</style>
